import React, { Component, Fragment } from 'react';
import InputForm from 'components/components/common/forms/InputForm';
import axios from 'components/AppRequest';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import { Link } from 'react-router-dom';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';
import { Error } from 'components/common/Form.js';

class EmailForm extends Component {

  state = {
    errors: {},
    isLoading: false,
  }

  trans = (key, prefix = 'content.auth.emailForm') => {
    return TransHelper.translate(this.props.locale, prefix + "." + key);
  }

  transError = (key) => {
    return TransHelper.translate(this.props.locale, 'content.errors.auth.emailForm.' + key);
  }

  validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || email.trim() === '') {
      return this.transError('emailEmpty');
    }
    if (!emailRegex.test(email)) {
      return this.transError('emailInvalid');
    }
    return null;
  }

  submitForm = (e) => {
    e.preventDefault();
    //reset errors
    this.props.changeShowCommunicate(false);

    const emailError = this.validateEmail(this.props.email);

    if (emailError === null) {
      this.setState({
        errors: {},
        isLoading: true,
      });
      this.sendRequest();
    } else {
      this.setState({ errors: { email: emailError } });
    }
  }

  sendRequest = () => {
    const { email } = this.props;
    axios.post('/pwa/registration/request-change-password', { email: email })
      .then(response => {
        this.setState({ isLoading: false });
        this.props.toggleView();
      })
      .catch(err => {
        console.log("err", err.response)
        this.setState({
          errors: err.response.data.errors || { email: this.transError('requestError') },
          isLoading: false
        });
      });
  }

  render() {
    const { errors, isLoading } = this.state;
    const { email } = this.props;
    return (
      <Fragment>
        <header className="head mb-30">
          <h3>{this.trans('title')}</h3>
          <p style={{ maxWidth: '250px', margin: '0 auto' }}>
            {this.trans('description')}
          </p>
        </header>

        <div className="content">
          <form onSubmit={this.submitForm}>
            <fieldset>
              <legend className="visuallyhidden">Email Form</legend>
              <CommunicateBox
                isStatic
                isSuccess
                message={this.trans('successMessage')}
                show={this.props.showCommunicate}
                hideCallback={() => this.props.changeShowCommunicate(false)}
              />
              <ul className="list-fields list-none mb-40">
                <li className="list-fields__item">
                  <InputForm
                    id="email"
                    name="_email_reset"
                    type="email"
                    label={this.trans('emailLabel')}
                    value={email}
                    handleChange={this.props.changeEmail}
                  />
                  <Error error={errors.email} />
                </li>
              </ul>

              <p className="text-right text-small mb-30" style={{ marginTop: '-10px' }}>
                {this.trans('remember')}<AppLink to="routes.url.login">{this.trans('goBack')}</AppLink>
              </p>

              {isLoading
                ?
                <LoadingSpinner className="button button--expand" />
                :
                <button className="button button--expand">{this.trans('resetPasswordButton')}</button>
              }
            </fieldset>
          </form>
        </div>
      </Fragment>
    );
  }
}

export default EmailForm;
